import { DropDownListItem, defaultDropDownListItem } from '../common/dropDownListResponse';

export interface ClaimSimple {
    claimID: number; 
    insClaimNumber: string;
    status: string; 
    insuranceCompany: string; 
    insuredPerson: string;
    adjuster: DropDownListItem; 
    examiner: DropDownListItem;
    director: DropDownListItem; 
    reviewer: DropDownListItem; 
    lossCause: string; 
    lossDescription: string; 
    catCode: string; 
    claimType: string; 
    reopenReason: string; 
    grossLoss: number; 
    dateLoss: Date | null;
    dateReported: Date | null;
    dateReceived: Date | null;
    dateReopened: Date | null;
    dateClosed: Date | null;
}

export const defaultClaimSimple: ClaimSimple = {
    claimID: 0, 
    insClaimNumber: '',
    status: '', 
    insuranceCompany: '', 
    insuredPerson: '',
    adjuster: defaultDropDownListItem, 
    examiner: defaultDropDownListItem, 
    director: defaultDropDownListItem, 
    reviewer: defaultDropDownListItem,
    lossCause: '', 
    lossDescription: '', 
    catCode: '', 
    claimType: '', 
    reopenReason: '', 
    grossLoss: 0, 
    dateLoss: null,
    dateReported: null,
    dateReceived: null,
    dateReopened: null,
    dateClosed: null,
}
